import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as auth from '~/services/auth/auth.service';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import authApi from '~/api/auth/auth.api';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { alertSwal } from '~/utils/helpers';
const MySwal = withReactContent(Swal);

let loginCount = 0;
let message = 'There is something wrong at CSRF verification process. Please contact your developer.';

export const authLogin = ({ email, password, setError, setErrorMsg, formikBag }) => {
    return async (dispatch) => {
        try {
            let res = await authApi.apiLogin({ email, password });
            await auth.storeToken(res.data.accessToken);
            auth.storeLogInStatus();
            dispatch(login());
        } catch (err) {
            let message = err?.data?.message ?? err.statusText;

            if (err.status === 422) {
                const errorBags = err.data.errors;
                let errors = [];
                for (const key in errorBags) {
                    errorBags[key].forEach((item) => errors.push(item));
                }

                message = errors;
            }

            //if login is rejected at server due to csrf, call authApi.getCsrf() and re-dispatch the thunk action.
            if (err.status === 419) {
                if (loginCount <= 2) {
                    await authApi.getCsrf();
                    loginCount++;
                    return dispatch(
                        authLogin({
                            email: email,
                            password: password,
                            setError,
                            setErrorMsg,
                            formikBag,
                        }),
                    );
                } else {
                    return alertSwal('error', message);
                }
            }

            setError(true);
            setErrorMsg(message);
        } finally {
            formikBag.setSubmitting(false);
        }
    };
};

let logoutCount = 0;
export const authLogout = (navigate = null) => {
    return async (dispatch) => {
        try {
            await authApi.apiLogout();
        } catch (err) {
            //if logout is rejected at server due to csrf, call authApi.getCsrf() and re-dispatch the thunk action.
            if (err.status === 419) {
                if (logoutCount <= 2) {
                    await authApi.getCsrf();
                    logoutCount++;
                    return dispatch(authLogout(navigate));
                } else {
                    return alertSwal('error', message);
                }
            }
        } finally {
            auth.logoutFE(dispatch, navigate);
        }
    };
};

export const authRetrievePassword = createAsyncThunk('auth/authRetrievePassword', async (_, { dispatch }) => {
    try {
        dispatch(requestStarted());
        await authApi.retrievePassword();
        dispatch(requestFinished());
        MySwal.fire({
            title: <strong>Success!</strong>,
            html: (
                <p className="text-center font-weight-bold">
                    Password has been sent to ***erxo***fic***@g***.com. <br></br>You should receive it within 5
                    minutes.
                </p>
            ),
            icon: 'success',
        });
    } catch (error) {
        console.log(error);
    }
});

export const authSlice = createSlice({
    name: 'auth',
    initialState: { isAuthenticated: auth.getLogInStatus() },
    reducers: {
        login(state) {
            state.isAuthenticated = true;
        },
        logout(state) {
            state.isAuthenticated = false;
        },
    },
});
export const { login, logout } = authSlice.actions;
